function isPC () {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.includes(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export default isPC;


// WEBPACK FOOTER //
// ./src/utils/isPC.js